/* eslint-disable */

import { useEffect } from "react";

export default function Entry() {
  var isEntry = true;

  const printAndromedaMessage = () => {
    console.log(
      `%c
    _              _                              _       
   / \\   _ __   __| |_ __ ___  _ __ ___   ___  __| | __ _ 
  / _ \\ | '_ \\ / _\` | '__/ _ \\| '_ \` _ \\ / _ \\/ _\` |/ _\` |
 / ___ \\| | | | (_| | | | (_) | | | | | |  __/ (_| | (_| |
/_/   \\_\\_| |_|\\__,_|_|  \\___/|_| |_| |_|\___| \\__,_|\\__,_|

`,
      "color: #078cf9; font-size: 16px; font-weight: bold;"
    );

    console.log(
      "%cThis website is being Developed and Hosted by Andromeda Hosting. If you would like to inquire about our services, please visit our website at: https://andromeda-hosting.com",
      "color: #078cf9; font-size: 15px; font-weight: semibold;"
    );

    console.log(
      '%cPasting code into the console can be dangerous to your computer. If someone told you to copy-paste something here to enable a feature or "hack" someone\'s account, it is a scam and will give them access to your computer',
      "color: red; font-size: 15px; font-weight: semibold;"
    );
  };

  useEffect(() => {
    if (isEntry) {
      // Ensure app defaults to dark luxury theme on first load
      try {
        document.documentElement.classList.add("dark");
      } catch (e) {
        // ignore if document not available
      }
      printAndromedaMessage();
      isEntry = false;
    }
  }, []);

  return null;
}
